module.exports = __webpack_public_path__ + "static/WelcomeToElk12-9d5b85c311e6289f4aebed903d30e6e9.webp";